import { render, staticRenderFns } from "./VersionDetailContent.vue?vue&type=template&id=4926e01f&"
import script from "./VersionDetailContent.vue?vue&type=script&lang=ts&"
export * from "./VersionDetailContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports